<div class="detail-page__rail-content" *ngIf="(business.airports && business.airports.length) || editModeSet">
  <div class="section__right-rail">
    <div class="section__header">
      <h2 class="section__header-text">Associated Airports</h2>
      <button id="add_btn" *ngIf="editModeSet && !isAmbassador && !isRegionalManager" (click)="openAddAirportsDialog()" mat-mini-fab>
        <mat-icon aria-label="Add Associated Airport">add</mat-icon>
      </button>
    </div>
    <div class="section__body">
      <ul class="associated-airports__list">
        <li *ngFor="let airport of business.airports" class="associated-airports__airport">
          <mat-icon
            *ngIf="editModeSet && !isAmbassador"
            (click)="removeAirport(airport)"
            class="delete-icon"
            mat-tooltip="Remove Airport"
            aria-label="Button deletes row">
            delete_outline
          </mat-icon>
          <div class="associated-airports__airport-name">{{ airport.name }}</div>
          <a class="associated-airports__airport-link" [routerLink]="(airport.sourceId === 10 || airport.sourceId === 12) ?
          ['/airports', airport.identifier, 'island'] : ['/airports', airport.identifier]">View Details</a>
        </li>
      </ul>
    </div>
  </div>
</div>
